<template>
<div class="page_smart_park page_hezuo pB100">
	<div class="form_wrap">
		<div class="item">
			<div class="title">入馆时间</div>
			<div class="name">
				<span class="">{{ userTicket.date_at }}</span>
				<span class="pd20">{{ userTicket.beigin_at + '-' + userTicket.end_at }}</span>
			</div>
		</div>
		<div class="item" @click="showTeamType=true">
			<div class="title">团体类型</div>
			<div class="name">
				<span class="">{{ team_type?team_type.name:'请选择团队类型' }}</span>
			</div>
		</div>
		<div class="item">
			<div class="title">团体名称</div>
			<div class="name">
				<van-field v-model="team_name" placeholder="请填写团体名称（必填）" />
			</div>
		</div>
		<div class="item">
			<div class="title">领队姓名</div>
			<div class="name">
				<van-field v-model="name" placeholder="请填写领队姓名（必填）" />
			</div>
		</div>
		<div class="item">
			<div class="title">领队电话</div>
			<div class="name">
				<van-field v-model="phone" placeholder="请填写领队电话（必填）" />
			</div>
		</div>
		<div class="item">
			<div class="title">身份证号</div>
			<div class="name">
				<van-field v-model="id_card" placeholder="请填写身份证号（必填）" />
			</div>
		</div>
		<div class="item">
			<div class="title">团队人数{{team_num>0&&ticket_price>0?('（预计费用:￥'+team_num*ticket_price+'）'):''}}</div>
			<div class="name">
				<van-field v-model="team_num" placeholder="请填写团队人数" />
			</div>
		</div>
		<!-- <div class="item">
			<div class="title">行程单号</div>
			<div class="name">
				<van-field v-model="itinerary" placeholder="请填写行程单号（必填）" />
			</div>
		</div> -->
		<div class="item">
			<div class="title">备注</div>
			<div class="name">
				<van-field v-model="remark" placeholder="请您填写备注信息..." />
			</div>
		</div>
	</div>
	<!-- 附加服务 -->
		<div class="form_wrap" v-if="servicesArr && servicesArr.length != 0">
			<div class="item">
				<div class="title">附加服务</div>
				<van-checkbox-group v-model="services_list" @change="changeServices">
					<van-checkbox checked-color="#D34444" v-for="item in servicesArr" :key="item.id" :name="item.id">
						<span class="name">{{ item.name }}</span>
						<!-- <span class="price">{{ '¥'+ item.prices}}</span> -->
					</van-checkbox>
				</van-checkbox-group>
			</div>
		</div>
		<!-- 接待员 -->
		<div class="form_wrap" v-if="receperArr && receperArr.length != 0">
			<div class="item">
				<div class="title">接待员</div>
				<van-radio-group v-model="receper_id" >
					<van-radio checked-color="#D34444" v-for="item in receperArr" :key="item.id" :name="item.id" @click="changeReceper(item)">
						<span class="name">{{ item.name }}</span>
					</van-radio>
				</van-radio-group>
			</div>
		</div>
	<div class="bottom">
		<div class="action big" @click="tijiao">提交</div>
	</div>
	<van-popup v-model="showTeamType" round position="bottom">
		<van-picker
			show-toolbar
			:columns="teamTypeShowList"
			@cancel="showTeamType = false"
			@confirm="onConfirm"
		/>
	</van-popup>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
			userTicket: null, // 用户已选的票务信息
			showTeamType: false,
			teamTypeList: [], // 团队类型
			teamTypeShowList: [], // 团队类型
			team_type: null, // 
			team_name: null,
			name: null,
			phone: null,
			id_card: null,
			itinerary: null,
			remark: null,
			team_num: null,// 团队人数
			servicesArr: [],
			receperArr: [],
			services_list: [], // 附加服务 服务ID [1,2]
			receper_id: '', // 接待员ID
			ticket_price: 0
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '团队预约',

                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						// 票务信息
						this.userTicket = JSON.parse(localStorage.getItem('userTicket'))
						this.getServices()
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			// 票务信息
			this.userTicket = JSON.parse(localStorage.getItem('userTicket'))
			this.getServices()
        }
		this.getTeamType()
		
    },
	mounted() {
	},
	destroyed() {
		var that = this
		// console.log('销毁了吗=====')
		localStorage.removeItem('visitorList')
		localStorage.removeItem('setInfoArr')
		localStorage.removeItem('services_list')
		localStorage.removeItem('receper_ids')
	},
    methods: {
		getTeamType(){
			var that = this
			that.$api.smartpark.teamtype().then(res=>{
				if(res.code == 200){
					that.teamTypeList = res.result
					that.teamTypeShowList = []
					for (let i = 0; i < that.teamTypeList.length; i++) {
						const type = that.teamTypeList[i];
						that.teamTypeShowList.push(type.name)
					}
				}
			});
		},
		onConfirm(value) {
			var that = this
			for (let i = 0; i < that.teamTypeList.length; i++) {
				const type = that.teamTypeList[i];
				if (type.name == value) {
					this.team_type = type
					break
				}
			}
			this.showTeamType = false;
		},
		// 附加服务
		getServices(){
			var that = this
			var params = {
				token: that.token,
				venue_id: that.userTicket.venue_id,
				smarkpark_id: that.userTicket.smarkpark_id,
				is_through_ticket: that.userTicket.is_through_ticket,
				ticket_id: that.userTicket.id,
				sorce: 1
			}
			console.log(1111111)
			that.$api.smartpark.setinfo(params).then(res=>{
				if(res.code == 200){
					that.ticket_price = res.result.ticket_price
					// 附加服务
					that.servicesArr = res.result.smarkpark_additional_services
					// 缓存中有已选服务,显出出来
					var services_list = localStorage.getItem('services_list')
					if(services_list){
						that.services_list = JSON.parse(services_list)
					}
					// 配置信息
					var arr = []
					var enterinfo = res.result.smartpark_enterinfo_set
					for (var i in enterinfo) {
                        arr.push({
                            key: enterinfo[i].name,
                            value: ''
                        });
                    }
					that.setInfoArr = arr
					// 缓存中有配置信息,显示出来
					var setInfoArr = localStorage.getItem('setInfoArr')
					if(setInfoArr){
						that.setInfoArr = JSON.parse(setInfoArr)
					}
					// 接待员
					that.receperArr = res.result.smartpark_receper
					// 缓存中有接待员,显出出来
					var receper_ids = localStorage.getItem('receper_ids')
					if(receper_ids){
						that.receper_ids = JSON.parse(receper_ids)
					}
				}
			})
		},
		// 选择服务
		changeServices(){
			var that = this
			// 存下已选服务
			localStorage.setItem('services_list',JSON.stringify(that.services_list))
			// // 更新费用
			// that.updatePrice()
		},
		// 选择接待员
		changeReceper(event){
			var that = this
			// if (this.receper_id == event.id) {
			// 	this.receper_id = ''
			// } else {
			// 	this.receper_id = event.id
			// }
			// console.log(event.id)
			// console.log(this.receper_id)
			// 存下已选服务
			localStorage.setItem('receper_ids',JSON.stringify(that.receper_ids))
		},
		// 提交
		tijiao(){
			var that = this
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {
					},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							that.token = data.result.token;
							that.commitAction()
						} else {
							that.token = "";
						}
						// 调用某方法
					}
				);
			} else {
				this.commitAction()
			}
		},
		commitAction() {
			var that = this
			var params = {
				token: that.token,
				ticket_id: that.userTicket.id
			}
			// 团体类型
			if(!that.team_type){
				that.$toast('请填写团体类型')
				return
			}else{
				params.team_type = that.team_type.id
			}
			// 团体名称
			if(!that.team_name){
				that.$toast('请填写团体名称')
				return
			}else{
				params.team_name = that.team_name
			}
			// 领队名称
			if(!that.name){
				that.$toast('请填写领队名称')
				return
			}else{
				params.name = that.name
			}
			// 手机号
			if(!that.phone){
				that.$toast('请填写手机号')
				return
			}else if( !(/^1[3456789]\d{9}$/.test(that.phone)) ){
				that.$toast('请检查手机号是否正确')
				return
			}else{
				params.phone = that.phone
			}
			// 身份证
			if(!that.id_card){
				that.$toast('请填写身份证号')
				return
			}else{
				params.id_card = that.id_card
			}
			if (that.team_num) {
				params.team_num = that.team_num
			}
			
			// // 行程单
			// if(!that.itinerary){
			// 	that.$toast('请填写行程单')
			// 	return
			// }else{
			// 	params.itinerary = that.itinerary
			// }
			// 备注
			if(that.remark){
				params.remark = that.remark
			}
			if (that.services_list && that.services_list.length > 0) {
				params.services_list = that.services_list
			}
			if (that.receper_id && that.receper_id != undefined && that.receper_id != '') {
				params.receper_ids = that.receper_id
			}
			that.$api.smartpark.teamorder(params).then(res=>{
				if(res.code == 200){
					that.$toast(res.message)
					if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
						var params = {
							'data': {
								'url': that.$publicData.clientUrl + '/smartpark/order?order_type=2'
								}
							}
						that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						that.$router.push({
							path: '/smartpark/order',
							query: {
								order_type: 2 // 订单类型 团体2
							}
						})
					}
					
				}
			})
		}
        
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
